import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-jalaali';
import { parse } from 'querystring';


@Pipe({
  name: 'dateformater'
})
export class DateformaterPipe implements PipeTransform {

  transform(value: any, timeStructure: number = 1, lang = 'fa') {
    if (!value) { return ''; }
    if (value) {
      const md = moment(value);
      if (!md.isValid()) { return value; }
      if (lang === 'fa') {
        switch (timeStructure) {
          case 1: //
            return md.format('HH:mm:ss jYYYY/jMM/jDD');
          case 2: //
            return md.format('jYYYY/jMM/jDD');
          case 3: //
            return md.format('HH:mm');
          case 4: //
            return md.format('HH:mm jMM/jDD');
          case 5: //
            return md.jDayOfYear() + this.monthString(md.jMonth()) + md.format('jYY');
          default:
            return md.format('HH:mm:ss jYYYY/jMM/jDD');
        }
      } else {
        switch (timeStructure) {
          case 1: //
            return md.format('YYYY/MM/DD HH:mm:ss');
          case 2: //
            return md.format('YYYY/MM/DD');
          case 3: //
            return md.format('HH:mm');
          case 4: //
            return md.format('MM/DD HH:mm:ss');
          default:
            return md.format('YYYY/MM/DD HH:mm:ss');

        }
      }
    } else {
      return null;
    }

  }
  monthString(month) {
    switch (month) {
      case 1:
        return 'فروردین';
      case 2:
        return 'اردیبهشت';
      case 3:
        return 'خرداد';
      case 4:
        return 'تیر';
      case 5:
        return 'مرداد';
      case 6:
        return 'شهریور';
      case 7:
        return 'مهر';
      case 8:
        return 'آبان';
      case 9:
        return 'آذر';
      case 10:
        return 'دی';
      case 11:
        return 'بهمن';
      case 12:
        return 'اسفند';

    }
  }

}
